<template>
  <b-container fluid style="margin-top: 20px;">
    <b-row class="text-left">
      <!--            <b-col>-->
      <!--                <h5 class="title">-->
      <!--                    {{section}}-->
      <!--                </h5>-->
      <!--            </b-col>-->
    </b-row>
    <b-row class="text-left">
      <b-col>
        <b-nav pills>
          <b-nav-item
            v-for="menu in subMenuList"
            :key="menu.value"
            :active="menu.value === menuSelected"
            :class="{
              'tab-selector': true,
              active: menu.value === menuSelected,
            }"
            exact-active-class="active"
            link-classes="tab-selector"
            @click="
              (el) => {
                menuSelected = menu.value;
              }
            "
          >
            {{ menu.name }}
          </b-nav-item>
        </b-nav>
      </b-col>
    </b-row>
    <b-row class="content">
      <user-view v-if="menuSelected === 'user'" />
      <s-p-p-view v-if="menuSelected === 'spp'" />
      <breed-view v-if="menuSelected === 'breed'" />
      <direction-view v-if="menuSelected === 'direction'" />
      <cancel-reason-view v-if="menuSelected === 'cancelReason'" />
      <remark-view v-if="menuSelected === 'remark'" />
      <!--      <test-type-view v-if="menuSelected === 'testType'" />-->
      <test-view v-if="menuSelected === 'testType'" />
      <set-test-view v-if="menuSelected === 'setTest'" />
      <specimen-type v-if="menuSelected === 'specimenType'" />
      <!--            <test-view v-if="menuSelected === 'test'" />-->
      <item-view v-if="menuSelected === 'item'" />
      <permission-view v-if="menuSelected === 'permission'" />
      <user-history v-if="menuSelected === 'userHistory'" />
      <promotion v-if="menuSelected === 'promotion'" />
      <test-history v-if="menuSelected === 'testHistory'" />
      <corporation-account v-if="menuSelected === 'corporationAccount'" />
      <unit v-if="menuSelected === 'unit'" />
    </b-row>
  </b-container>
</template>

<script>
import UserView from "./User";
import SPPView from "./SPP";
import Unit from "./Unit";
import BreedView from "./Breed";
import RemarkView from "./Remark";
import TestTypeView from "./TestType";
// import TestView from "./Test"
import ItemView from "./Item";
import PermissionView from "./Permission";
import UserHistory from "./UserHistory";
import SpecimenType from "./SpecimenType";
import Promotion from "./Promotion";
import TestView from "./TestView";
import SetTestView from "./SetTestView";
import DirectionView from "../../components/Settings/Direction/DirectionView";
import TestHistory from "./TestHistory";
import CancelReasonView from "./CancelReason";
import CorporationAccount from "./CorporationAccount";

export default {
  name: "Main",
  components: {
    DirectionView,
    SetTestView,
    TestView,
    Promotion,
    UserView,
    SPPView,
    BreedView,
    CancelReasonView,
    RemarkView,
    TestTypeView,
    TestHistory,
    // TestView,
    ItemView,
    PermissionView,
    UserHistory,
    SpecimenType,
    CorporationAccount,
    Unit,
  },
  props: {},
  data() {
    return {
      section: "Settings",
      menuSelected: "",
      subMenuList: [
        {
          name: "USER",
          value: "user",
        },
        {
          name: "SPP",
          value: "spp",
        },
        {
          name: "BREED",
          value: "breed",
        },
        {
          name: "เส้นทางวิ่ง",
          value: "direction",
        },
        {
          name: "เหตุผลที่ยกเลิก",
          value: "cancelReason",
        },
        {
          name: "REMARK",
          value: "remark",
        },
        {
          name: "รายการตรวจ",
          value: "testType",
        },
        {
          name: "ชุดตรวจ",
          value: "setTest",
        },
        // {
        //   name: 'รายการตัวอย่าง',
        //   value: 'specimenType'
        // },
        // {
        //   name: 'รายการตรวจ',
        //   value: 'test'
        // },
        {
          name: "รายการสินค้า",
          value: "item",
        },
        {
          name: "โปรโมชั่น",
          value: "promotion",
        },
        {
          name: "สิทธิ์ผู้ใช้งาน",
          value: "permission",
        },
        {
          name: "ประวัติการใช้งาน",
          value: "userHistory",
        },
        {
          name: "ประวัติการตรวจ",
          value: "testHistory",
        },
        {
          name: "บัญชี",
          value: "corporationAccount",
        },
        {
          name: "Unit",
          value: "unit",
        },
      ],
    };
  },
  mounted() {
    this.menuSelected = this.subMenuList[0].value;
  },
};
</script>

<style lang="scss" scoped>
.title {
  padding: 2rem;
}
.content {
  padding: 2rem;
}
</style>
